/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/progressbar/progressbar_styles';



/* ========== ~~~~~~~~~~ PROGRESS BAR ~~~~~~~~~~ ========== */
const ProgressBar = (props) => {
	return (
        <div className={`progressbar ${props.classes.progressbar}`}>
            <div className={`bar foreground`} style={{backgroundColor: props.foreground, width: props.fill}} />
            <div className={`bar background`} style={{backgroundColor: props.background}} />
        </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ProgressBar);
